console.log("Hello from app/javascript/submission_show.js")



function togglePin(analyteID, flagType) {
    console.log(`Toggling pin for analyte ID: ${analyteID}`);
    let flagIcon;
    if (flagType === "sample") {
        flagIcon = document.querySelector(`#analyte-results-table-sample-id-${sampleID} .bi-flag-fill`);
    } else if (flagType === "analyte") {
        flagIcon = document.querySelector(`#analytes-table-flag-${analyteID} .bi-flag-fill`);
    }
    if (!flagIcon) return;

    const parent = flagIcon.parentElement;

    // Ensure the parent is relatively positioned for absolute pin placement
    if (getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
    }

    const alreadyPinned = flagIcon.dataset.toggled === "true";

    if (alreadyPinned) {
        // Unpin: remove pin icon and update attribute
        const pinIcon = parent.querySelector(`.bi.bi-pin-fill.pin-overlay-icon#pin-icon-${sampleID}`);
        if (pinIcon) pinIcon.remove();
        flagIcon.dataset.toggled = "false";
    } else {
        // Pin: add pin icon and update attribute
        const pinIcon = document.createElement('i');
        pinIcon.className = 'bi bi-pin-fill pin-overlay-icon';
        pinIcon.id = `pin-icon-${sampleID}`;
        pinIcon.classList.add('text-stroke-1');
        parent.appendChild(pinIcon);
        flagIcon.dataset.toggled = "true";
    }
}


